/**
 * Meeting status constants.
 *
 * Complete `meeting_status` value set (contact_meetings.status; mirrored by
 * codegen `Meeting_Status`). Use `z.enum(MEETING_STATUS_VALUES)` for meeting
 * forms/inputs — never a hand-typed literal (a schema that omitted `rescheduled`
 * silently rejected rescheduled meetings). `satisfies readonly Meeting_Status[]`
 * breaks `tsc` if the DB enum drifts after codegen.
 */

import type { Meeting_Status } from "@/src/gql/graphql";

export const MEETING_STATUS_VALUES = [
  "scheduled",
  "completed",
  "cancelled",
  "rescheduled",
] as const satisfies readonly Meeting_Status[];
